import { Component, type ReactNode } from 'react';

type State = { error: Error | null };

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override render() {
    if (this.state.error) {
      return (
        <div className="flex h-full flex-col items-center justify-center p-6 text-center">
          <h2 className="font-display text-lg text-ink">Something tripped us up.</h2>
          <p className="mt-2 max-w-sm text-sm text-ink-muted">
            Refresh the page to try again. Your saved work is still there.
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}
